import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteService } from '../../../services/expediente.service';
import { TableColumn } from '../../../dto/util/table-column';
import { ExpedienteSuperfinancieraFiltroDto } from '../../../dto/expediente/expediente-superfinanciera.filtro.dto';
import { ExpedienteSuperfinancieraDto } from '../../../dto/expediente/expediente-superfinanciera.dto';
import { HistorialExpedienteSuperfinancieraDto } from '../../../dto/expediente/historial-expediente-superfinanciera.dto';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { UtilService } from '../../../services/util.service';
import { Constants } from '../../../constants/constants';
import { DescargaDocumentosComponent } from '../descarga-documentos/descarga-documentos.component';
import { ModalService } from '../../../services/util/modal.service';
import { DocumentosService } from '../../../services/documentos.service';
import { DocumentosDescargaRequestDto } from '../../../dto/expediente/documentos.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { Entidades } from '../../../constants/entidades.constants';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import {EntidadService} from "../../../services/entidad.service";
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";

@Component({
  selector: 'app-detalle-superfinanciera',
  templateUrl: './detalle-superfinanciera.component.html',
  styleUrl: './detalle-superfinanciera.component.scss',
})
export class DetalleSuperfinancieraComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  expedienteSuperfinancieraDto?: ExpedienteSuperfinancieraDto;
  historialExpediente: HistorialExpedienteSuperfinancieraDto[] = [];
  idExpediente = 0;
  entidadId = 4;
  columns: TableColumn[] = [];
  filtros: FiltroDto<ExpedienteSuperfinancieraFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'Radicado',
    filtros: {},
  };
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};

  guiaText: any = {};
  guiaSuperfinacnieraText: any = {};

  showGuia:boolean = true;
  entidad!: EntidadApiResponse;
  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';
  constructor(
    private readonly expedienteService: ExpedienteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly documentosService: DocumentosService,
    private readonly translate: TranslateService,
    private entidadService: EntidadService
  ) {
    // Multilenguaje
    combineLatest({
      table: this.translate.stream('detalle-superfinanciera'),
      guia: this.translate.stream('guias-interactivas'),
      guiaSuperfinacniera: this.translate.stream('guia-superfinanciera'),
    }).subscribe(({ table, guia, guiaSuperfinacniera }) => {
      // Asignar traducciones a variables
      this.tableText = table;
      this.guiaText = guia;
      this.guiaSuperfinacnieraText = guiaSuperfinacniera
      this.initColumns();
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.idExpediente = this.activatedRoute.snapshot.params['expedienteId'];
    this.cargarEntidad();
    const infoInicioSesion = JSON.parse(
     sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;
    this.filtradoExpediente(this.idExpediente,this.tipoDocumentoUsuario,this.numeroIdentificacion);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se toma la información del usuario que inicia sesión
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaSuperfinacnieraText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaSuperfinacnieraText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaSuperfinacnieraText['encabezado-titulo'],
            description: this.guiaSuperfinacnieraText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaSuperfinacnieraText['historico-titulo'],
            description: this.guiaSuperfinacnieraText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaSuperfinacnieraText['historico-titulo'],
            description: this.guiaSuperfinacnieraText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaSuperfinacnieraText['filtro-titulo'],
            description: this.guiaSuperfinacnieraText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#fecha_radicacion',
          popover: {
            title: this.guiaSuperfinacnieraText['fecha-radicacion-titulo'],
            description:
              this.guiaSuperfinacnieraText['fecha-radicacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#radicacion',
          popover: {
            title: this.guiaSuperfinacnieraText['radicacion-titulo'],
            description: this.guiaSuperfinacnieraText['radicacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#nombre',
          popover: {
            title: this.guiaSuperfinacnieraText['nombre-titulo'],
            description: this.guiaSuperfinacnieraText['nombre-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#actividad',
          popover: {
            title: this.guiaSuperfinacnieraText['actividad-titulo'],
            description: this.guiaSuperfinacnieraText['actividad-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#principal',
          popover: {
            title: this.guiaSuperfinacnieraText['principal-titulo'],
            description: this.guiaSuperfinacnieraText['principal-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#adjuntos',
          popover: {
            title: this.guiaSuperfinacnieraText['adjuntos-titulo'],
            description: this.guiaSuperfinacnieraText['adjuntos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#anexos',
          popover: {
            title: this.guiaSuperfinacnieraText['anexos-titulo'],
            description: this.guiaSuperfinacnieraText['anexos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };

    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_SUPERFINANCIERA) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_SUPERFINANCIERA, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

 filtradoExpediente(idExpediente: number,tipoDocumentoUsuario:string,numeroIdentificacion:string) {
    this.expedienteService
      .getExpedientesSuperfinanciera(idExpediente,tipoDocumentoUsuario,numeroIdentificacion)
      .subscribe(response => {
        if (typeof response.fecha_creacion === 'string') {
          const fecha = new Date(response.fecha_creacion);
          if (!isNaN(fecha.getTime())) {
            response.fecha_creacion = fecha;
          } else {
            console.warn("Fecha inválida recibida:", response.fecha_creacion);
            response.fecha_creacion = undefined;
          }
        }

        this.expedienteSuperfinancieraDto = response;
        this.historialExpediente = this.expedienteSuperfinancieraDto[
          'actuaciones'
        ].map(historico => ({
          ...historico,
          adjuntos: 'Ver adjuntos',
          anexos: 'Ver anexos',
          principal: historico.principal,
        }));
        this.initColumns();
      });
  }

  initColumns() {
    this.columns = [
      {
        field: 'fecha_radicacion',
        title: this.tableText['fecha-radicacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fecha_radicacion',
        pipe: 'dd/MM/yyyy',
      },
      {
        field: 'radicacion',
        title: this.tableText['radicacion'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'radicacion',
      },
      {
        field: 'nombre',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'nombre',
      },
      {
        field: 'actividad',
        title: this.tableText['actividad'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'actividad',
      },
      {
        field: 'principal',
        title: this.tableText['principal'],
        type: 'text',
        filterable: false,
        sortable: false,
        fieldFilterElement: 'principal',
      },
      {
        field: 'adjuntos',
        title: this.tableText['adjuntos'],
        type: 'text',
        filterable: false,
        sortable: false,
        fieldFilterElement: 'adjuntos',
        accion: item => {
          this.openModal(item);
        },
      },
      {
        field: 'anexos',
        title: this.tableText['anexos'],
        type: 'text',
        filterable: false,
        sortable: false,
        fieldFilterElement: 'anexos',
        accion: item => {
          this.openModal(item);
        },
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}/solicitudes`,
    ]);
  }

  openModal(item: any) {
    const modalData: any = {
      ...item,
      entidadId: this.entidadId,
      expedienteId: this.idExpediente,
      nombreEntidad: Entidades.SFC,
    };
    this.modalService.openModal(DescargaDocumentosComponent, modalData);
  }

  downloadPrincipalDocument(item: any): void {
    const req: DocumentosDescargaRequestDto = {
      ids: [parseInt(item.principal)],
      idEntidad: this.entidadId,
      expediente: this.idExpediente,
    };

    this.documentosService.getDocumentosDescarga(
      req,
      this.idExpediente,
      Entidades.SFC
    );
  }

  private _downloadBase64File(base64: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = `data:application/octet-stream;base64,${base64}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }

}
